const calculateVideoClickPosition = (e) => {
  let elementHeight = e.target.offsetHeight;
  let elementWidth = e.target.offsetWidth;
  let videoHeight = e.target.videoHeight;
  let videoWidth = e.target.videoWidth;
  let ratio = elementHeight / videoHeight;
  let scaledWidth = videoWidth * ratio;
  let paddingLeft = Math.round((elementWidth - scaledWidth)/2);

  let rect = e.target.getBoundingClientRect();
  let x = e.clientX - rect.left - paddingLeft; //x position within the element.
  let y = e.clientY - rect.top;  //y position within the element.

  let originalX = (x / ratio).toFixed(0);
  let originalY = (y / ratio).toFixed(0);

  return {
    videoHeight,
    videoWidth,
    originalX,
    originalY
  }
};

export {
  calculateVideoClickPosition
}
